import React from 'react';
import _ from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { handleShowOn } from '../../services/functions';
import { useResponsive } from '../../services/hooks';
import ClickAwayListener from '@mui/material/ClickAwayListener';

export const InfoClearField = props => {
  const { info, formikValues, getFieldCallback, infoDynamicText } = props;
  const isDesktop = useResponsive('up', 'lg');
  const [showTooltip, setShowTooltip] = React.useState(false);

  // TODO ten title trzeba obsłużyć, komponent na szybko robiony
  const title = <Stack spacing={2}>
    <Typography>
    Mam świadomość, że powyższa zgoda jest w pełni dobrowolna i mogę ją wycofać w każdym czasie, bez wpływu na zgodność z prawem przetwarzania, które odbyło się przed wycofaniem.
    Cofnięcie zgody polega na przesłaniu nam stosownego oświadczenia w wiadomości e-mail na adres: sun-sport@sun-sport.pl lub w wiadomości SMS pod numer +48 602 119 000.
    </Typography>
    <Typography>
    Przesyłanie Tobie informacji o naszych promocjach, rabatach i nowościach (newsletter) wiąże się
    z przetwarzaniem przez nas Twoich danych osobowych. W związku z tym prosimy, abyś przed udostępnieniem swoich danych zapoznał(-a) się z informacjami o przetwarzaniu tych danych, które dostępne są pod linkiem <a target="_blank" href="https://sun-sport.pl/informacja-o-przetwarzaniu-danych-osobowych-w-celu-przesylania-newslettera-i-innych-informacji-handlowych/" rel="noreferrer">tutaj</a>.
    </Typography>
    <Typography>
    Wypełniając powyższy formularz oraz potwierdzając chęć otrzymywania informacji handlowych (przez zaznaczenie odpowiednich checkboxów i akceptację odpowiednim przyciskiem udzielasz nam zgody na używanie automatycznych systemów wywołujących ilub telekomunikacyjnych urządzeń końcowych, w szczególności w ramach korzystania z usług komunikacji interpersonalnej do celów przesyłania Tobie informacji handlowej w rozumieniu przepisów ustawy z dnia 18 lipca 2002 r. o świadczeniu usług drogą elektroniczną, w tym marketingu bezpośredniego naszych produktów, usług oraz wydarzeń związanych z SUN SPORT.
    </Typography>
  </Stack>;

  return (
    <Stack display="inline">
      <Typography variant="body1" style={{ paddingBottom: 7, paddingTop: 15, lineHeight: 1.5714285714285714, fontSize: '0.875rem', fontFamily: 'Public Sans,sans-serif', fontWeight: 400 }}>
        <span dangerouslySetInnerHTML={{ __html: `${info.label} ${infoDynamicText ?? ''}` }} />
        {isDesktop ? <Tooltip title={title} componentsProps={{
          tooltip: {
            sx: {
              maxWidth: '90vh',
              bgcolor: 'grey.200',
              color: 'primary.main',
              borderRadius: '8px',
              boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)',
              padding: '10px'

            }
          }
        }}>
          <span>
            <FontAwesomeIcon
              icon={['fas', 'question-circle']}
              color="primary"
              size="lg"
            />
          </span>
        </Tooltip> : <ClickAwayListener onClickAway={() => setShowTooltip(false)}><span><Tooltip
          disableFocusListener
          disableHoverListener
          disableTouchListener
          open={showTooltip}
          onOpen={() => setShowTooltip(true)}
          onClose={() => setShowTooltip(false)}
          title={title}
          componentsProps={{
            tooltip: {
              sx: {
                maxWidth: '90vh',
                bgcolor: 'grey.200',
                color: 'primary.main',
                borderRadius: '8px', // Zaokrąglone rogi
                boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)', // Lekkie cieniowanie
                padding: '10px' // Opcjonalnie: wewnętrzny odstęp

              }
            }
          }}>
          <span style={{ cursor: 'pointer' }} onClick={() => setShowTooltip(true)}>
            <FontAwesomeIcon
              icon={['fas', 'question-circle']}
              color="primary"
              size="lg"
            />
          </span>
        </Tooltip></span></ClickAwayListener>}
      </Typography>
    </Stack>
  );
};
